import { render } from "./Frontend.vue?vue&type=template&id=327e8d8a&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"

import "./Frontend.vue?vue&type=style&index=0&id=327e8d8a&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Tenisu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327e8d8a"]])

export default __exports__